import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import axios from "axios";

const N8N_CONFIRM_URL = process.env.REACT_APP_N8N_CONFIRM_WEBHOOK_URL;
const TSPM_API = "https://tspm-api.abrandfantastic.workers.dev";

const CMS_DEFAULTS = {
  lol_confirmed_headline: "You're on the list",
  lol_confirmed_subtext:  "If Lollipop comes back, you'll be the first to know.",
  lol_confirmed_message:  "Lollipop was more than a t-shirt label.\nIt was a statement. A feeling. A moment in time.\nMaybe it's time for another moment.",
};

export default function ConfirmPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [cms, setCms] = useState(CMS_DEFAULTS);
  const name = searchParams.get("name") || "Friend";

  useEffect(() => {
    fetch(`${TSPM_API}/api/site-content`)
      .then(r => r.json())
      .then(data => setCms(c => ({ ...c, ...Object.fromEntries(Object.keys(CMS_DEFAULTS).map(k => [k, data[k] ?? c[k]])) })))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      return;
    }

    axios
      .post(N8N_CONFIRM_URL, { token })
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [searchParams]);

  return (
    <div className="thankyou-page">
      <div className="top-marquee thankyou-marquee-top">
        <div className="marquee-track">
          {[...Array(10)].map((_, i) => (
            <span key={i} className="marquee-item">
              {status === "success"
                ? "YOU'RE CONFIRMED   ✦   WELCOME BACK   ✦   LOLLIPOP LIVES   ✦  "
                : "LOLLIPOP   ✦   REVIVE   ✦   HOUSE OF LOLLIPOP   ✦  "}
            </span>
          ))}
        </div>
      </div>

      <main className="thankyou-main">
        <div className="thankyou-container">
          {status === "loading" && (
            <motion.p
              className="thankyou-subtext"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              Confirming your spot...
            </motion.p>
          )}

          {status === "success" && (
            <>
              <motion.div
                className="stamp-wrapper"
                initial={{ scale: 0, rotate: -45 }}
                animate={{ scale: 1, rotate: -8 }}
                transition={{ type: "spring", stiffness: 300, damping: 15, delay: 0.2 }}
              >
                <div className="stamp">CONFIRMED</div>
              </motion.div>

              <motion.h1
                className="thankyou-headline"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                {cms.lol_confirmed_headline}, {name}
              </motion.h1>

              <motion.p
                className="thankyou-subtext"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                {cms.lol_confirmed_subtext.split('\n').map((line, i, arr) => (
                  <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
                ))}
              </motion.p>

              <motion.div
                className="message-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <p className="message-text">
                  {cms.lol_confirmed_message.split('\n').map((line, i, arr) => (
                    <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
                  ))}
                </p>
              </motion.div>
            </>
          )}

          {status === "error" && (
            <>
              <motion.h1
                className="thankyou-headline"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                Something went wrong
              </motion.h1>

              <motion.p
                className="thankyou-subtext"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                This link may have already been used or has expired.<br />
                Sign up again if you'd like a new confirmation email.
              </motion.p>
            </>
          )}

          <motion.button
            className="back-btn"
            onClick={() => navigate("/")}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <ArrowLeft size={18} />
            <span>Back to waitlist</span>
          </motion.button>
        </div>
      </main>

      <div className="bottom-bar">
        <div className="bottom-marquee">
          {[...Array(10)].map((_, i) => (
            <span key={i} className="bottom-item">
              LOLLIPOP + POPSICLE &nbsp; &nbsp;
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
